<template>
    <div class="card">
        <div class="card-header bg-primary text-white">Registros plantilla</div>
        <div class="card-body table-responsive">
            <div class="row">
                <div class="col-12 mb-2">
                    <a :href="getRecordsUrl($route.params.id)" class="btn btn-sm btn-success float-right ml-2">Descargar registros <i class="fas fa-file-excel"></i> </a>
                    <button @click="$refs['file-input'].click()" class="btn btn-sm btn-success float-right ml-2">Subir registros <i class="fas fa-file-excel"></i> </button>
                    <button @click="$refs['images-input'].click()" class="btn btn-sm btn-warning white-text float-right">Subir imágenes <i class="fas fa-image"></i></button>

                    <!-- Hidden inputs -->
                    <input style="display: none" @change="uploadExcel" ref="file-input" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                    <input style="display: none" type="file" name="" @change="uploadImages" ref="images-input" multiple id="" accept="image/jpeg">
                    <!-- /Hidden inputs -->
                </div>
            </div>
            <table class="table table-stripped" v-if="records.length">
                <thead>
                    <tr>
                        <th v-for="field in records[0].format.fields" :key="field.id">{{field.name}}</th>
                        <th>Firma</th>
                        <th>Imagen</th>
                        <th>Video</th>
                        <th>Audio</th>
                        <th>Historial</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="record in records" :key="record.id">
                        <td v-for="field in record.fields" :key="field.id">{{field.pivot.value}}</td>
                        <td>
                            <img v-if="record.signature" width="80" :src="record.signature" :alt="record.format.name">
                        </td>
                        <td>
                            <img v-if="!record.image.includes('IMG-')" width="80" :src="record.image" :alt="record.format.name">
                            <p v-else>{{record.image}}</p> 
                        </td>
                        <td>
                            <video height="120" controls v-if="record.video">
                                <source :src="record.video">
                            </video>
                            <p v-else>No disponible</p>
                        </td>
                        <td>
                            <audio controls v-if="record.audio">
                                <source :src="record.audio" type="audio/aac">
                            </audio>
                            <p v-else>No disponible</p>
                        </td>
                        <td>
                            <div class="history" v-if="record.history">
                                <div style="margin-bottom: 15px; border-radius: 7px; box-shadow: 0px 0px 5px lightgray; padding: 10px" v-for="(item, i) in record.history" :key="i">
                                    <p style="margin: 0">{{item.record.user.first_name}} {{item.record.user.last_name}}: [{{item.date}}]</p> 
                                    <p style="margin: 0" v-for="(jtem, j) in item.changes" :key="j">{{jtem}}</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="alert alert-danger" role="alert">
                No hay registros para este formato
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from 'vuex';
export default {
    name: "RecordList",
    props: {
        records: {
            type: Array,
            required: true
        }
    },
    mounted() {
        document.getElementsByClassName('history');
    },
    methods: {
        ...mapActions(['storeExcelRecords', 'updateRecordImages']),
        getRecordsUrl(id){
            return process.env.VUE_APP_API+'/entity/formats/'+id+'/records?excel=1&token='+localStorage.getItem('session_id');
        },
        async uploadExcel(e){
            let hasFiles = e.target.files.length > 0;
            if(!hasFiles) return;

            let data = new FormData();
            data.append('excel', e.target.files[0]);
            const format_id = this.$route.params.id;
            await this.storeExcelRecords({data, format_id});

            this.$refs['images-input'].click();
        },
        uploadImages(e){
            let hasFiles = e.target.files.length > 0;
            if(!hasFiles) return;

            let data = new FormData();
            let images = e.target.files;
            data.append('_method', 'put');
            for(let i = 0; i < images.length; i++){
                data.append(`images[${i}]`, images[i]);
            }

            const format_id = this.$route.params.id;
            this.updateRecordImages({data, format_id});
        }
    }
}
</script>

<style>
    .history {
        cursor: pointer;
    }
</style>